import { render, staticRenderFns } from "./CustomizedItemTextAndValue.vue?vue&type=template&id=1ce92434&"
import script from "./CustomizedItemTextAndValue.vue?vue&type=script&lang=js&"
export * from "./CustomizedItemTextAndValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports